import { Field, WrappedFieldProps } from 'redux-form';
import { StructuredDate } from '@optimus-web/core';
import { getError } from '../../utils';
import { SingleMonthStringPicker } from '../DateStringPicker';

export interface MonthStringPickerFieldProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value'> {
    minDate?: StructuredDate | null;
    showMonthSelector?: boolean;
}

const MonthStringPickerRenderer = ({ input, meta, ...props }: MonthStringPickerFieldProps & WrappedFieldProps) => (
    <SingleMonthStringPicker error={getError(meta)} {...props} {...input} />
);

const MonthStringPickerField = (props: MonthStringPickerFieldProps) => (
    <Field {...props} component={MonthStringPickerRenderer} />
);

export default MonthStringPickerField;
